import { createSlice } from "@reduxjs/toolkit";

export const getSummaryReportClientsMock = ({ summaryReportId }) => {
  const idToTimeMap = {
    "summary-report-2026-w33": 1786291200, // 2026-08-10 00:00:00 (Asia/Taipei)
    "summary-report-2026-w32": 1785686400, // 2026-08-03 00:00:00 (Asia/Taipei)
    "summary-report-2026-w31": 1785081600, // 2026-07-27 00:00:00 (Asia/Taipei)
  };

  let weekStartSecs = idToTimeMap[summaryReportId] || 1786291200; // 預設為 W33 起點

  if (!idToTimeMap[summaryReportId] && summaryReportId && summaryReportId.startsWith("summary-report-")) {
    const dateStr = summaryReportId.replace("summary-report-", "");
    const date = new Date(`${dateStr}T00:00:00`);
    if (!isNaN(date.getTime())) {
      weekStartSecs = Math.floor(date.getTime() / 1000);
    }
  }

  const T = weekStartSecs;
  const Hour = 3600;

  return {
    data: {
      items: [
        {
          clientId: "C-0128",
          macAddress: "3C:5A:B4:21:9F:01",
          vendor: "Apple",
          segments: [
            { status: "online", startedAt: T + 24 * Hour, endedAt: T + 76 * Hour },
            { status: "offline", startedAt: T + 76 * Hour, endedAt: T + 80 * Hour },
          ]
        },
        {
          clientId: "C-0134",
          macAddress: "28:CF:DA:72:04:55",
          vendor: "Samsung",
          segments: [
            { status: "online", startedAt: T, endedAt: T + 168 * Hour }
          ]
        },
        {
          clientId: "C-0138",
          macAddress: "68:72:C3:48:9A:11",
          vendor: "Samsung",
          segments: [
            { status: "online", startedAt: T, endedAt: T + 168 * Hour }
          ]
        },
        {
          clientId: "C-0131",
          macAddress: "78:4F:43:90:12:6E",
          vendor: "Google",
          segments: [
            { status: "offline", startedAt: T + 80 * Hour, endedAt: T + 89.5 * Hour }
          ]
        },
        {
          clientId: "C-0132",
          macAddress: "A8:5E:45:3C:11:AF",
          vendor: "Apple",
          segments: []
        },
        {
          clientId: "C-0133",
          macAddress: "F0:9F:C2:6B:48:9D",
          vendor: "Unknown",
          segments: [
            { status: "offline", startedAt: T + 140 * Hour, endedAt: T + 141 * Hour }
          ]
        },
        {
          clientId: "C-0129",
          macAddress: "44:65:0D:8E:3A:7C",
          vendor: "Samsung",
          segments: [
            { status: "offline", startedAt: T + 58 * Hour, endedAt: T + 59.5 * Hour },
            { status: "offline", startedAt: T + 111 * Hour, endedAt: T + 113 * Hour }
          ]
        },
        {
          clientId: "C-0135",
          macAddress: "14:5A:FC:19:88:C2",
          vendor: "Google",
          segments: [
            { status: "offline", startedAt: T + 104 * Hour, endedAt: T + 105 * Hour }
          ]
        },
        {
          clientId: "C-0136",
          macAddress: "D0:37:45:5E:A1:33",
          vendor: "Unknown",
          segments: [
            { status: "offline", startedAt: T + 8 * Hour, endedAt: T + 9 * Hour },
            { status: "offline", startedAt: T + 38 * Hour, endedAt: T + 39 * Hour },
            { status: "offline", startedAt: T + 82 * Hour, endedAt: T + 83 * Hour },
            { status: "offline", startedAt: T + 116 * Hour, endedAt: T + 117 * Hour },
            { status: "offline", startedAt: T + 156 * Hour, endedAt: T + 157 * Hour }
          ]
        },
        {
          clientId: "C-0137",
          macAddress: "50:EB:71:2A:BC:70",
          vendor: "Apple",
          segments: [
            { status: "offline", startedAt: T + 162 * Hour, endedAt: T + 163 * Hour }
          ]
        },
        {
          clientId: "C-0130",
          macAddress: "9C:D2:1E:45:77:2B",
          vendor: "Microsoft",
          segments: [
            { status: "offline", startedAt: T + 33 * Hour, endedAt: T + 34 * Hour }
          ]
        },
        {
          clientId: "C-0139",
          macAddress: "90:B1:D5:7F:EA:00",
          vendor: "Apple",
          segments: [
            { status: "offline", startedAt: T + 2 * Hour, endedAt: T + 3 * Hour }
          ]
        },
        {
          clientId: "C-0140",
          macAddress: "40:55:39:1A:BC:E2",
          vendor: "Google",
          segments: []
        },
        {
          clientId: "C-0141",
          macAddress: "FC:BD:02:11:A3:44",
          vendor: "Microsoft",
          segments: [
            { status: "online", startedAt: T, endedAt: T + 168 * Hour }
          ]
        },
        {
          clientId: "C-0142",
          macAddress: "3C:90:E5:8E:77:FF",
          vendor: "Apple",
          segments: [
            { status: "offline", startedAt: T + 48 * Hour, endedAt: T + 50 * Hour }
          ]
        },
        {
          clientId: "C-0143",
          macAddress: "22:A1:CB:59:71:02",
          vendor: "Samsung",
          segments: [
            { status: "offline", startedAt: T + 15 * Hour, endedAt: T + 18 * Hour }
          ]
        },
        {
          clientId: "C-0144",
          macAddress: "D4:33:0C:FA:68:BD",
          vendor: "Unknown",
          segments: [
            { status: "offline", startedAt: T + 36 * Hour, endedAt: T + 38 * Hour }
          ]
        },
        {
          clientId: "C-0145",
          macAddress: "9C:00:FF:E2:B3:7C",
          vendor: "Google",
          segments: [
            { status: "offline", startedAt: T + 96 * Hour, endedAt: T + 97 * Hour }
          ]
        },
        {
          clientId: "C-0146",
          macAddress: "8A:E5:41:88:9C:31",
          vendor: "Apple",
          segments: [
            { status: "online", startedAt: T, endedAt: T + 168 * Hour }
          ]
        },
        {
          clientId: "C-0147",
          macAddress: "A0:BC:02:D4:5E:82",
          vendor: "Samsung",
          segments: [
            { status: "offline", startedAt: T + 72 * Hour, endedAt: T + 75 * Hour }
          ]
        },
        {
          clientId: "C-0148",
          macAddress: "34:8B:11:EA:FC:E2",
          vendor: "Microsoft",
          segments: [
            { status: "offline", startedAt: T + 120 * Hour, endedAt: T + 122 * Hour }
          ]
        },
        {
          clientId: "C-0149",
          macAddress: "5A:C3:FF:EA:BD:30",
          vendor: "Google",
          segments: [
            { status: "offline", startedAt: T + 48 * Hour, endedAt: T + 50 * Hour }
          ]
        },
        {
          clientId: "C-0150",
          macAddress: "68:BC:C2:EA:44:91",
          vendor: "Apple",
          segments: [
            { status: "online", startedAt: T, endedAt: T + 168 * Hour }
          ]
        },
        {
          clientId: "C-0151",
          macAddress: "4C:5E:2B:1A:BC:F0",
          vendor: "Samsung",
          segments: [
            { status: "offline", startedAt: T + 6 * Hour, endedAt: T + 8 * Hour }
          ]
        },
        {
          clientId: "C-0152",
          macAddress: "E0:EB:77:24:BD:7C",
          vendor: "Google",
          segments: []
        }
      ]
    }
  };
};

const initialState = {
  data: {
    items: []
  }
};

const summaryReportClientsSlice = createSlice({
  name: "summaryReportClients",
  initialState,
});

export default summaryReportClientsSlice.reducer;
